import { createApi } from '@reduxjs/toolkit/query/react';
import { baseTasksQuery } from './config';
import { UTMParameters } from 'src/types/models/UTMParameters';

export const utmApi = createApi({
  reducerPath: 'utmApi',
  baseQuery: baseTasksQuery,
  endpoints: (build) => ({
    logUTMParameters: build.mutation<
      void,
      UTMParameters & {
        user_id: string;
      }
    >({
      query: ({ user_id, source, campaign, medium }) => ({
        url: `users/${user_id}/utm/log`,
        method: 'POST',
        body: { source, campaign, medium },
      }),
    }),
  }),
});

export const { useLogUTMParametersMutation } = utmApi;
